// Gemeinsames "Papier"-Grundgerüst für Verträge/Angebote: weiße A4-Seite mit Schatten
// auf grauem Hintergrund (wie ein PDF-Viewer), Toolbar mit Druck/PDF-Buttons.
export const PDF_PAGE_CSS = `
        *{margin:0;padding:0;box-sizing:border-box;}
        @page{size:A4;margin:18mm 20mm;}
        html{background:#5c5c5c;}
        body{font-family:Arial,Helvetica,sans-serif;font-size:13px;color:#111;background:#5c5c5c;line-height:1.55;min-height:100vh;}
        .toolbar{position:sticky;top:0;z-index:2;display:flex;gap:10px;padding:14px 16px;background:#3f3f42;}
        .toolbar button{font-family:Arial,Helvetica,sans-serif;font-size:14px;font-weight:700;padding:10px 20px;border-radius:8px;cursor:pointer;border:none;}
        .toolbar .dl{background:#fb923c;color:#1a1a1a;}
        .toolbar .pr{background:#fff;color:#111;}
        @media print{.toolbar{display:none;}}
        .page-wrap{padding:28px 16px 48px;display:flex;justify-content:center;align-items:flex-start;overflow:hidden;}
        #doc-content{width:210mm;flex-shrink:0;background:#fff;box-shadow:0 8px 40px rgba(0,0,0,0.45);padding:18mm 20mm;color:#111;}
        @media print{
            html,body{background:#fff;}
            .page-wrap{padding:0;display:block;overflow:visible;}
            #doc-content{box-shadow:none;width:auto;padding:0;transform:none !important;}
        }
`;

export const PDF_TOOLBAR_HTML = `
    <div class="toolbar">
        <button class="dl" id="dl-btn">⬇ PDF herunterladen</button>
        <button class="pr" id="pr-btn">Drucken</button>
    </div>`;

// Selbe CSP-Situation überall: Inline onclick/<script> wird von der CSP (script-src 'self')
// geblockt, deshalb hängen wir Listener vom Opener aus per addEventListener an.
export function wireDocWindow(win, filename, avoidSelectors = ['.section']) {
    if (!win || !win.document) return;
    const dlBtn = win.document.getElementById('dl-btn');
    const prBtn = win.document.getElementById('pr-btn');
    const page = win.document.getElementById('doc-content');
    const wrap = win.document.querySelector('.page-wrap');
    const naturalWidth = 793.7007874015749; // 210mm bei 96dpi

    // Die Seite bleibt in echter A4-Breite gerendert (korrekter Zeilenumbruch/Schriftgröße)
    // und wird per transform als Ganzes herunterskaliert, statt die Breite zu quetschen —
    // sonst bricht der Text auf schmalen Screens in viel mehr Zeilen um und wirkt gestaucht/riesig.
    const applyScale = () => {
        if (!page || !wrap) return;
        const available = wrap.clientWidth;
        const scale = available > 0 ? Math.min(1, available / naturalWidth) : 1;
        page.style.transformOrigin = 'top center';
        page.style.transform = scale < 1 ? `scale(${scale})` : 'none';
        wrap.style.height = scale < 1 ? `${page.offsetHeight * scale}px` : 'auto';
    };
    const resetScale = () => {
        if (!page) return;
        page.style.transform = 'none';
        if (wrap) wrap.style.height = 'auto';
    };

    // html2pdf klont #doc-content in einen Container, der bei gesetztem margin bereits auf
    // (Seitenbreite − Rand) verschmälert ist — unsere feste 210mm-Breite würde darin nach rechts
    // überlaufen (sichtbar als "rechtsbündiger" Versatz). Für den Export daher kurz auf 100% (füllt
    // exakt den margin-schmalen Container) und ohne eigenes Padding (der Rand kommt dann nur noch
    // von html2pdf selbst, sonst doppelt sich das auf der ersten/letzten Seite).
    const forExport = (fn) => {
        if (!page) return fn();
        const prevWidth = page.style.width;
        const prevPadding = page.style.padding;
        page.style.width = '100%';
        page.style.padding = '0';
        const restore = () => { page.style.width = prevWidth; page.style.padding = prevPadding; };
        try { return fn(restore); } catch (e) { restore(); throw e; }
    };

    applyScale();
    win.addEventListener('resize', applyScale);
    win.addEventListener('beforeprint', resetScale);
    win.addEventListener('afterprint', applyScale);

    if (prBtn) prBtn.addEventListener('click', () => win.print());
    if (dlBtn) {
        dlBtn.addEventListener('click', () => {
            resetScale();
            dlBtn.disabled = true;
            dlBtn.textContent = 'Erstelle PDF…';
            forExport((restore) => {
                win.html2pdf().from(page).set({
                    filename: `${filename || 'Dokument'}.pdf`,
                    margin: win.Array.of(18, 20, 18, 20),
                    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
                    html2canvas: { scale: 2 },
                    pagebreak: { mode: ['css', 'legacy'], avoid: avoidSelectors }
                }).save().then(() => {
                    restore();
                    applyScale();
                    dlBtn.disabled = false;
                    dlBtn.textContent = '⬇ PDF herunterladen';
                }).catch((err) => {
                    restore();
                    applyScale();
                    dlBtn.disabled = false;
                    dlBtn.textContent = '⬇ PDF herunterladen';
                    win.alert('PDF konnte nicht erstellt werden: ' + (err && err.message ? err.message : err));
                });
            });
        });
    }
}
